<template>
  <div>
    <div v-for="(facetElement, index) in facetElements" :key="index" style="height: 18px; overflow:hidden;">
      <facet-checkbox-element-component :name="facetElement.name" :displayName="facetElement.displayName" :count="facetElement.count" :type="facetElement.type" :mutationName="mutationName"></facet-checkbox-element-component>
    </div>
  </div>
</template>

<script>
import store from "../../store/ObservationsStore.js";
import facetCheckboxElementComponent from "./facet-checkbox-element-component.vue";

/**
 * This component coantains as many sub-component as there is filters to diplay iin facet classification result.
 * For each filter a sub component is created and the filter name, the filter count, the filter type, and the
 * vuex filter store mutation name are passed
 */
export default {
  //Facet classification and vuex filter store mutation name passed by parent component
  props: ["facetElements", "mutationName"],
    components:{
    facetCheckboxElementComponent
  },
};
</script>

<style>
.custom label {
  float: left;
}
</style>
